<div *ngIf="results.contactPersons.enabled">
	<h2>{{results.contactPersons.title}}</h2>
	<table class="table">
		<tr>
			<th class="edit-width" aria-label="Edit Column"></th>
			<th class="active-date-width">Active Date</th>
			<th class="type-width">{{results.contactPersons.header}} Type</th>
			<th>{{results.contactPersons.header}}</th>
		</tr>
		<tr *ngFor="let current of results.contactPersons.current; let i = index">
			<td>
				<span>
					<button type="button" class="icon-3-4" mat-icon-button color="primary" aria-label="Edit"
						[matTooltip]="'Edit ' + results.contactPersons.header" matTooltipPosition="above"
						(click)="edit('contactPersons', current)">
						<mat-icon>edit</mat-icon>
					</button>
				</span>
				<confirm-popover [type]="'button'" class="icon-3-4" [buttonType]="'mini-icon'" [icon]="'delete'"
					[popoverMsg]="'Delete ' + results.contactPersons.header" [color]="'accent'"
					(onConfirm)="deleteContactMechanism('contactPersons', current, i)">
				</confirm-popover>
			</td>
			<td>{{current.CREATED_DATE! | simpleDate}}</td>
			<td>{{current.PARTY_CONTACT_MECHANISM_PURPOSES![0].CONTACT_MECHANISM_PURPOSE_TYPES!.TYPE}}
			</td>
			<td> {{current.CONTACT_MECHANISMS!.CONTACT_PERSONS![0].FIRST_NAME}}
				{{current.CONTACT_MECHANISMS!.CONTACT_PERSONS![0].LAST_NAME}}</td>
		</tr>
	</table>

	<div *ngIf="!results.contactPersons.inserting && !results.contactPersons.editing" class="padding-horizontal-sm">
		<button mat-raised-button color="primary" (click)="insert('contactPersons')">New
			{{results.contactPersons.header}}</button>
	</div>

	<form #contactPersonForm="ngForm" *ngIf="results.contactPersons.inserting || results.contactPersons.editing">
		<mat-card appearance="outlined">
			<mat-card-title *ngIf="results.contactPersons.inserting">
				New {{results.contactPersons.header}}
			</mat-card-title>
			<mat-card-title *ngIf="results.contactPersons.editing">
				Editing {{results.contactPersons.header}}
			</mat-card-title>
			<mat-card-content>
				<div class="row">
					<mat-form-field class="col-xs-4 col-sm-4 col-md-4 col-lg-4 col-xl-4">
						<mat-label>
							{{results.contactPersons.header}} Type
						</mat-label>
						<mat-select id="Contact Mechanism Type" name="Contact Mechanism Type"
							[(ngModel)]="results.contactPersons.edit.PARTY_CONTACT_MECHANISM_PURPOSES![0].CONTACT_MECHANISM_PURPOSE_TYPES"
							[compareWith]="trackById" required="true">
							<mat-option
								*ngFor="let type of sortContactMechanismPurposeTypes('TYPE') | hasPartialTypeString: ['Administrator'] | hasPartialTypeString: filterContactPersonTypes"
								[value]="type">
								{{ type.TYPE }}
							</mat-option>
						</mat-select>

					</mat-form-field>
					<mat-form-field class="col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6">
						<mat-label>
							First Name
						</mat-label>
						<input matInput type="string" id="First Name" name="First Name" placeholder="First Name"
							required="true"
							[(ngModel)]="results.contactPersons.edit.CONTACT_MECHANISMS!.CONTACT_PERSONS![0].FIRST_NAME" />
					</mat-form-field>

					<mat-form-field class="col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6">
						<mat-label>
							Last Name
						</mat-label>
						<input matInput type="string" id="Last Name" name="Last Name" placeholder="Last Name"
							required="true"
							[(ngModel)]="results.contactPersons.edit.CONTACT_MECHANISMS!.CONTACT_PERSONS![0].LAST_NAME" />
					</mat-form-field>
				</div>
			</mat-card-content>
			<mat-card-footer class="padding-sm">

				<confirm-popover [type]="'submit'" [buttonTxt]="'Add'"
					[popoverMsg]="'Add new ' + results.contactPersons.header" *ngIf="results.contactPersons.inserting"
					[disabled]="contactPersonForm.invalid || false"
					(onConfirm)="insertContactMechanism('contactPersons')">
				</confirm-popover>

				<confirm-popover [type]="'submit'" [buttonTxt]="'Update'"
					[popoverMsg]="'Confirm ' + results.contactPersons.header + ' update'"
					*ngIf="results.contactPersons.editing" [disabled]="contactPersonForm.invalid || false"
					(onConfirm)="updateContactMechanism('contactPersons')">
				</confirm-popover>

				<button mat-raised-button (click)="editDone('contactPersons')">Cancel</button>
			</mat-card-footer>
		</mat-card>
	</form>


	<mat-accordion class="margin-horizontal-xs">
		<mat-expansion-panel>
			<mat-expansion-panel-header>
				<mat-panel-title class="danger">
					Past {{results.contactPersons.header}}(s) ({{results.contactPersons.past.length}})
				</mat-panel-title>
				<mat-panel-description>
				</mat-panel-description>
			</mat-expansion-panel-header>

			<table class="table">
				<tr>
					<th class="edit-width2" aria-label="Edit Column"></th>
					<th class="active-date-width">Active Date</th>
					<th class="type-width">{{results.contactPersons.header}} Type</th>
					<th>{{results.contactPersons.header}}</th>
				</tr>
				<tr *ngFor="let past of results.contactPersons.past">
					<td><!--
						<button class="icon-3-4" mat-icon-button color="primary"  >mat-mini-fab [color]="'primary'"
							<mat-icon>edit</mat-icon>
						</button> -->
					</td>
					<td>{{past.CREATED_DATE! | simpleDate}}</td>
					<td>{{past.PARTY_CONTACT_MECHANISM_PURPOSES![0].CONTACT_MECHANISM_PURPOSE_TYPES!.TYPE}}
					</td>
					<td> {{past.CONTACT_MECHANISMS!.CONTACT_PERSONS![0].FIRST_NAME}}
						{{past.CONTACT_MECHANISMS!.CONTACT_PERSONS![0].LAST_NAME}}</td>
				</tr>
			</table>
		</mat-expansion-panel>
	</mat-accordion>
</div>

<div *ngIf="results.postalAddresses.enabled">
	<h2>{{results.postalAddresses.title}}</h2>
	<table class="table">
		<tr>
			<th class="edit-width" aria-label="Edit Column"></th>
			<th class="active-date-width">Active Date</th>
			<th class="type-width">{{results.postalAddresses.header}} Type</th>
			<th>{{results.postalAddresses.header}}</th>
		</tr>
		<tr *ngFor="let current of results.postalAddresses.current; let i = index">
			<td>
				<span>
					<button type="button" class="icon-3-4" mat-icon-button color="primary" aria-label="Edit"
						[matTooltip]="'Edit ' + results.postalAddresses.header" matTooltipPosition="above"
						(click)="edit('postalAddresses', current)">
						<mat-icon>edit</mat-icon>
					</button>
				</span>
				<confirm-popover [type]="'button'" class="icon-3-4" [buttonType]="'mini-icon'" [icon]="'delete'"
					[popoverMsg]="'Delete ' + results.postalAddresses.header" [color]="'accent'"
					(onConfirm)="deleteContactMechanism('postalAddresses', current, i)">
				</confirm-popover>
			</td>
			<td>{{current.CREATED_DATE! | simpleDate}}</td>
			<td>{{current.PARTY_CONTACT_MECHANISM_PURPOSES ?
				current.PARTY_CONTACT_MECHANISM_PURPOSES![0].CONTACT_MECHANISM_PURPOSE_TYPES!.TYPE: ''}}
			</td>
			<td>
				{{current.CONTACT_MECHANISMS ? current.CONTACT_MECHANISMS!.POSTAL_ADDRESSES![0].STREET_1 : ''}}
				{{current.CONTACT_MECHANISMS ? current.CONTACT_MECHANISMS!.POSTAL_ADDRESSES![0].STREET_2 : ''}}
				{{current.CONTACT_MECHANISMS ? current.CONTACT_MECHANISMS!.POSTAL_ADDRESSES![0].CITy!.CITY_NAME : ''}}
				{{current.CONTACT_MECHANISMS ? current.CONTACT_MECHANISMS!.POSTAL_ADDRESSES![0].CITy!.STATE!.STATE_CODE
				+ ','
				: ''}}
				{{current.CONTACT_MECHANISMS ?
				current.CONTACT_MECHANISMS!.POSTAL_ADDRESSES![0].POSTAL_CODES!.POSTAL_CODE : ''}}
			</td>
		</tr>
	</table>

	<div *ngIf="!results.postalAddresses.inserting && !results.postalAddresses.editing" class="padding-horizontal-sm">
		<button mat-raised-button color="primary" (click)="insert('postalAddresses')">New
			{{results.postalAddresses.header}}</button>
	</div>

	<form #addressForm="ngForm" *ngIf="results.postalAddresses.inserting || results.postalAddresses.editing">
		<mat-card appearance="outlined">
			<mat-card-title *ngIf="results.postalAddresses.inserting">
				New {{results.postalAddresses.header}}
			</mat-card-title>
			<mat-card-title *ngIf="results.postalAddresses.editing">
				Editing {{results.postalAddresses.header}}
			</mat-card-title>
			<mat-card-content>
				<div class="row">
					<mat-form-field class="col-xs-4 col-sm-4 col-md-4 col-lg-4 col-xl-4">
						<mat-label>
							{{results.postalAddresses.header}} Type
						</mat-label>
						<mat-select id="Contact Mechanism Type" name="Contact Mechanism Type"
							[(ngModel)]="results.postalAddresses.edit.PARTY_CONTACT_MECHANISM_PURPOSES![0].CONTACT_MECHANISM_PURPOSE_TYPES"
							[compareWith]="trackById" required="true">
							<mat-option
								*ngFor="let type of sortContactMechanismPurposeTypes('TYPE') | hasPartialTypeString: ['Address'] | removePartialTypeString : ['Phone'] | hasPartialTypeString: filterAddressTypes"
								[value]="type">
								{{ type.TYPE }}
							</mat-option>
						</mat-select>

					</mat-form-field>
					<mat-form-field class="col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6">
						<mat-label>
							Street Address
						</mat-label>
						<input matInput type="string" id="Street Address 1" name="Street Address 1"
							placeholder="Street Address 1" required="true"
							[(ngModel)]="results.postalAddresses.edit.CONTACT_MECHANISMS!.POSTAL_ADDRESSES![0].STREET_1" />
					</mat-form-field>

					<mat-form-field class="col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6">
						<mat-label>
							Street Address 2
						</mat-label>
						<input matInput type="string" id="Street Address 2" name="Street Address 2"
							placeholder="Street Address 2"
							[(ngModel)]="results.postalAddresses.edit.CONTACT_MECHANISMS!.POSTAL_ADDRESSES![0].STREET_2" />
					</mat-form-field>
				</div>
				<div class="row">
					<input-city-autocomplete class="col-xs-3 col-sm-3 col-md-3 col-lg-3 col-xl-3" [id]="'City'"
						[name]="'City'" [label]="'City'" [placeholder]="'City'" [(selectedCity)]="city"
						[(state)]="state" [required]="true">
					</input-city-autocomplete>

					<input-state-autocomplete class="col-xs-3 col-sm-3 col-md-3 col-lg-3 col-xl-3" [id]="'State'"
						[name]="'State'" [label]="'State'" [placeholder]="'State'" [(selectedState)]="state"
						[required]="true"></input-state-autocomplete>

					<input-zipcode-autocomplete class="col-xs-3 col-sm-3 col-md-3 col-lg-3 col-xl-3" [id]="'ZIP code'"
						[name]="'ZIP code'" [label]="'ZIP code'" [placeholder]="'ZIP code'"
						[(selectedZipcode)]="zipcode" [required]="true" [countryId]="1">
					</input-zipcode-autocomplete>
				</div>
			</mat-card-content>
			<mat-card-footer class="padding-sm">

				<confirm-popover [type]="'submit'" [buttonTxt]="'Add'"
					[popoverMsg]="'Add new ' + results.postalAddresses.header" *ngIf="results.postalAddresses.inserting"
					[disabled]="addressForm.invalid || !city.ID || !state.ID || !zipcode.ID"
					(onConfirm)="insertContactMechanism('postalAddresses')">
				</confirm-popover>

				<confirm-popover [type]="'submit'" [buttonTxt]="'Update'"
					[popoverMsg]="'Confirm ' + results.postalAddresses.header + ' update'"
					*ngIf="results.postalAddresses.editing"
					[disabled]="addressForm.invalid || !city.ID || !state.ID || !zipcode.ID"
					(onConfirm)="updateContactMechanism('postalAddresses')">
				</confirm-popover>

				<button mat-raised-button (click)="editDone('postalAddresses')">Cancel</button>
			</mat-card-footer>
		</mat-card>
	</form>

	<mat-accordion class="margin-horizontal-xs">
		<mat-expansion-panel>
			<mat-expansion-panel-header>
				<mat-panel-title class="danger">
					Past {{results.postalAddresses.header}}(es) ({{results.postalAddresses.past.length}})
				</mat-panel-title>
				<mat-panel-description>
				</mat-panel-description>
			</mat-expansion-panel-header>

			<table class="table">
				<tr>
					<th class="edit-width2" aria-label="Edit Column"></th>
					<th class="active-date-width">Active Date</th>
					<th class="type-width">{{results.postalAddresses.header}} Type</th>
					<th>{{results.postalAddresses.header}}</th>
				</tr>
				<tr *ngFor="let past of results.postalAddresses.past">
					<td></td>
					<td>{{past.CREATED_DATE! | simpleDate}}</td>
					<td>{{past.PARTY_CONTACT_MECHANISM_PURPOSES![0].CONTACT_MECHANISM_PURPOSE_TYPES!.TYPE}}
					</td>
					<td>
						{{past.CONTACT_MECHANISMS!.POSTAL_ADDRESSES![0].STREET_1}}
						{{past.CONTACT_MECHANISMS!.POSTAL_ADDRESSES![0].STREET_2}}
						{{past.CONTACT_MECHANISMS!.POSTAL_ADDRESSES![0].CITy!.CITY_NAME}}
						{{past.CONTACT_MECHANISMS!.POSTAL_ADDRESSES![0].CITy!.STATE!.STATE_CODE}},
						{{past.CONTACT_MECHANISMS!.POSTAL_ADDRESSES![0].POSTAL_CODES!.POSTAL_CODE}}
					</td>
				</tr>
			</table>
		</mat-expansion-panel>
	</mat-accordion>
</div>

<div *ngIf="results.phoneNumbers.enabled">
	<h2>{{results.phoneNumbers.title}}</h2>
	<table class="table">
		<tr>
			<th class="edit-width" aria-label="Edit Column"></th>
			<th class="active-date-width">Active Date</th>
			<th class="type-width">{{results.phoneNumbers.header}} Type</th>
			<th>{{results.phoneNumbers.header}}</th>
		</tr>
		<tr *ngFor="let current of results.phoneNumbers.current; let i = index">
			<td>
				<span>
					<button type="button" class="icon-3-4" mat-icon-button color="primary" aria-label="Edit"
						[matTooltip]="'Edit ' + results.phoneNumbers.header" matTooltipPosition="above"
						(click)="edit('phoneNumbers', current)">
						<mat-icon>edit</mat-icon>
					</button>
				</span>
				<confirm-popover [type]="'button'" class="icon-3-4" [buttonType]="'mini-icon'" [icon]="'delete'"
					[popoverMsg]="'Delete ' + results.phoneNumbers.header" [color]="'accent'"
					(onConfirm)="deleteContactMechanism('phoneNumbers', current, i)">
				</confirm-popover>
			</td>
			<td>{{current.CREATED_DATE! | simpleDate}}</td>
			<td>{{current.PARTY_CONTACT_MECHANISM_PURPOSES![0].CONTACT_MECHANISM_PURPOSE_TYPES!.TYPE}}
			</td>
			<td>{{current.CONTACT_MECHANISMS!.TELEPHONE_NUMBERS![0].PHONE_NUMBER +
				(current.CONTACT_MECHANISMS!.TELEPHONE_NUMBERS![0].EXT ? ' Ext. ' +
				current.CONTACT_MECHANISMS!.TELEPHONE_NUMBERS![0].EXT : '')}}</td>
		</tr>
	</table>

	<div *ngIf="!results.phoneNumbers.inserting && !results.phoneNumbers.editing" class="padding-horizontal-sm">
		<button mat-raised-button color="primary" (click)="insert('phoneNumbers')">New
			{{results.phoneNumbers.header}}</button>
	</div>

	<form #phoneNumberForm="ngForm" *ngIf="results.phoneNumbers.inserting || results.phoneNumbers.editing">
		<mat-card appearance="outlined">
			<mat-card-title *ngIf="results.phoneNumbers.inserting">
				New {{results.phoneNumbers.header}}
			</mat-card-title>
			<mat-card-title *ngIf="results.phoneNumbers.editing">
				Editing {{results.phoneNumbers.header}}
			</mat-card-title>
			<mat-card-content>
				<div class="row">
					<mat-form-field class="col-xs-4 col-sm-4 col-md-4 col-lg-4 col-xl-4">
						<mat-label>
							{{results.phoneNumbers.header}} Type
						</mat-label>
						<mat-select id="Contact Mechanism Type" name="Contact Mechanism Type"
							[(ngModel)]="results.phoneNumbers.edit.PARTY_CONTACT_MECHANISM_PURPOSES![0].CONTACT_MECHANISM_PURPOSE_TYPES"
							[compareWith]="trackById" required="true">
							<mat-option
								*ngFor="let type of sortContactMechanismPurposeTypes('TYPE') | hasPartialTypeString: ['Phone'] | hasPartialTypeString: filterPhoneNumberTypes"
								[value]="type">
								{{ type.TYPE }}
							</mat-option>
						</mat-select>

					</mat-form-field>
					<mat-form-field class="col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6">
						<mat-label>
							Phone Number
						</mat-label>
						<input matInput type="string" id="Phone Number" name="Phone Number" placeholder="123-456-7890"
							required="true"
							[(ngModel)]="results.phoneNumbers.edit.CONTACT_MECHANISMS!.TELEPHONE_NUMBERS![0].PHONE_NUMBER"
							telephoneValidator />
					</mat-form-field>

					<mat-form-field class="col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6">
						<mat-label>
							Ext
						</mat-label>
						<input matInput type="string" id="Ext" name="Ext" placeholder="" required="false"
							[(ngModel)]="results.phoneNumbers.edit.CONTACT_MECHANISMS!.TELEPHONE_NUMBERS![0].EXT" />
					</mat-form-field>
				</div>
			</mat-card-content>
			<mat-card-footer class="padding-sm">

				<confirm-popover [type]="'submit'" [buttonTxt]="'Add'"
					[popoverMsg]="'Add new ' + results.phoneNumbers.header" *ngIf="results.phoneNumbers.inserting"
					[disabled]="phoneNumberForm.invalid || false" (onConfirm)="insertContactMechanism('phoneNumbers')">
				</confirm-popover>

				<confirm-popover [type]="'submit'" [buttonTxt]="'Update'"
					[popoverMsg]="'Confirm ' + results.phoneNumbers.header + ' update'"
					*ngIf="results.phoneNumbers.editing" [disabled]="phoneNumberForm.invalid || false"
					(onConfirm)="updateContactMechanism('phoneNumbers')">
				</confirm-popover>

				<button mat-raised-button (click)="editDone('phoneNumbers')">Cancel</button>
			</mat-card-footer>
		</mat-card>
	</form>

	<mat-accordion class="margin-horizontal-xs">
		<mat-expansion-panel>
			<mat-expansion-panel-header>
				<mat-panel-title class="danger">
					Past {{results.phoneNumbers.header}}(s) ({{results.phoneNumbers.past.length}})
				</mat-panel-title>
				<mat-panel-description>
				</mat-panel-description>
			</mat-expansion-panel-header>

			<table class="table">
				<tr>
					<th class="edit-width2" aria-label="Edit Column"></th>
					<th class="active-date-width">Active Date</th>
					<th class="type-width">{{results.phoneNumbers.header}} Type</th>
					<th>{{results.phoneNumbers.header}}</th>
				</tr>
				<tr *ngFor="let past of results.phoneNumbers.past">
					<td></td>
					<td>{{past.CREATED_DATE! | simpleDate}}</td>
					<td>{{past.PARTY_CONTACT_MECHANISM_PURPOSES![0].CONTACT_MECHANISM_PURPOSE_TYPES!.TYPE}}
					</td>
					<td>{{past.CONTACT_MECHANISMS!.TELEPHONE_NUMBERS![0].PHONE_NUMBER +
						(past.CONTACT_MECHANISMS!.TELEPHONE_NUMBERS![0].EXT ? ' Ext. ' +
						past.CONTACT_MECHANISMS!.TELEPHONE_NUMBERS![0].EXT : '')}}</td>
				</tr>
			</table>
		</mat-expansion-panel>
	</mat-accordion>
</div>

<div *ngIf="results.emails.enabled">
	<h2>{{results.emails.title}}</h2>
	<table class="table">
		<tr>
			<th class="edit-width" aria-label="Edit Column"></th>
			<th class="active-date-width">Active Date</th>
			<th class="type-width">{{results.emails.header}} Type</th>
			<th>{{results.emails.header}}</th>
		</tr>
		<tr *ngFor="let current of results.emails.current; let i = index">
			<td>
				<span>
					<button type="button" class="icon-3-4" mat-icon-button color="primary" aria-label="Edit"
						[matTooltip]="'Edit ' + results.emails.header" matTooltipPosition="above"
						(click)="edit('emails', current)">
						<mat-icon>edit</mat-icon>
					</button>
				</span>
				<confirm-popover [type]="'button'" class="icon-3-4" [buttonType]="'mini-icon'" [icon]="'delete'"
					[popoverMsg]="'Delete ' + results.emails.header" [color]="'accent'"
					(onConfirm)="deleteContactMechanism('emails', current, i)">
				</confirm-popover>
			</td>
			<td>{{current.CREATED_DATE! | simpleDate}}</td>
			<td>{{current.PARTY_CONTACT_MECHANISM_PURPOSES![0].CONTACT_MECHANISM_PURPOSE_TYPES!.TYPE}}
			</td>
			<td>{{current.CONTACT_MECHANISMS!.EMAILS![0].EMAIL_ADDRESS}}</td>
		</tr>
	</table>

	<div *ngIf="!results.emails.inserting && !results.emails.editing" class="padding-horizontal-sm">
		<button mat-raised-button color="primary" (click)="insert('emails')">New
			{{results.emails.header}}</button>
	</div>

	<form #emailForm="ngForm" *ngIf="results.emails.inserting || results.emails.editing">
		<mat-card appearance="outlined">
			<mat-card-title *ngIf="results.emails.inserting">
				New {{results.emails.header}}
			</mat-card-title>
			<mat-card-title *ngIf="results.emails.editing">
				Editing {{results.emails.header}}
			</mat-card-title>
			<mat-card-content>
				<div class="row">
					<mat-form-field class="col-xs-4 col-sm-4 col-md-4 col-lg-4 col-xl-4">
						<mat-label>
							{{results.emails.header}} Type
						</mat-label>
						<mat-select id="Contact Mechanism Type" name="Contact Mechanism Type"
							[(ngModel)]="results.emails.edit.PARTY_CONTACT_MECHANISM_PURPOSES![0].CONTACT_MECHANISM_PURPOSE_TYPES"
							[compareWith]="trackById" required="true">
							<mat-option
								*ngFor="let type of sortContactMechanismPurposeTypes('TYPE') | hasPartialTypeString: ['Email'] | hasPartialTypeString: filterEmailTypes"
								[value]="type">
								{{ type.TYPE }}
							</mat-option>
						</mat-select>

					</mat-form-field>
					<mat-form-field>
						<mat-label>
							Email
						</mat-label>
						<input matInput type="email" id="Email" name="Email" placeholder="email@domain.org"
							required="true"
							[(ngModel)]="results.emails.edit.CONTACT_MECHANISMS!.EMAILS![0].EMAIL_ADDRESS" />
					</mat-form-field>

				</div>
			</mat-card-content>
			<mat-card-footer class="padding-sm">

				<confirm-popover [type]="'submit'" [buttonTxt]="'Add'" [popoverMsg]="'Add new ' + results.emails.header"
					*ngIf="results.emails.inserting" [disabled]="emailForm.invalid || false"
					(onConfirm)="insertContactMechanism('emails')">
				</confirm-popover>

				<confirm-popover [type]="'submit'" [buttonTxt]="'Update'"
					[popoverMsg]="'Confirm ' + results.emails.header + ' update'" *ngIf="results.emails.editing"
					[disabled]="emailForm.invalid || false" (onConfirm)="updateContactMechanism('emails')">
				</confirm-popover>

				<button mat-raised-button (click)="editDone('emails')">Cancel</button>
			</mat-card-footer>
		</mat-card>
	</form>

	<mat-accordion class="margin-horizontal-xs">
		<mat-expansion-panel>
			<mat-expansion-panel-header>
				<mat-panel-title class="danger">
					Past {{results.emails.header}}(s) ({{results.emails.past.length}})
				</mat-panel-title>
				<mat-panel-description>
				</mat-panel-description>
			</mat-expansion-panel-header>

			<table class="table">
				<tr>
					<th class="edit-width2" aria-label="Edit Column"></th>
					<th class="active-date-width">Active Date</th>
					<th class="type-width">{{results.emails.header}} Type</th>
					<th>{{results.emails.header}}</th>
				</tr>
				<tr *ngFor="let past of results.emails.past">
					<td></td>
					<td>{{past.CREATED_DATE! | simpleDate}}</td>
					<td>{{past.PARTY_CONTACT_MECHANISM_PURPOSES![0].CONTACT_MECHANISM_PURPOSE_TYPES!.TYPE}}
					</td>
					<td>{{past.CONTACT_MECHANISMS!.EMAILS![0].EMAIL_ADDRESS}}</td>
				</tr>
			</table>
		</mat-expansion-panel>
	</mat-accordion>
</div>